'use client'
import * as Accordion from 'primitives/accordion'
import { tw } from 'utils/classnames'
import { ChevronRightIcon } from 'primitives/icons'

import { useCategoriesDataContext, useOpenCategories } from './context'
import type { Collapsible } from './context'

interface CollapsibleProps {
  value: Collapsible
  children: React.ReactNode
}

export function Item({ value, children }: CollapsibleProps) {
  return (
    <Accordion.Item value={value} className="group/trigger w-full border-b border-[#DFDDE5]">
      {children}
    </Accordion.Item>
  )
}

export function Trigger({ children, className }: React.PropsWithChildren<{ className?: string }>) {
  return (
    <Accordion.Header asChild>
      <div>
        <Accordion.Trigger
          className={tw(
            'flex w-full items-center justify-between hover:cursor-pointer',
            'text-14 h-auto min-h-10 text-center font-bold',
            className,
          )}
          icon={
            <ChevronRightIcon className="group-data-[state='open']/trigger:bg-cf-dreamy-cloud-400 aspect-square size-10 rotate-90 transform rounded-full p-3 transition-all group-data-[state='open']/trigger:-rotate-90" />
          }
        >
          <h2 className="block w-full">{children}</h2>
        </Accordion.Trigger>
      </div>
    </Accordion.Header>
  )
}

export function Content({ children, className }: React.PropsWithChildren<{ className?: string }>) {
  const open = useOpenCategories()
  const isAnyOpen = open.length > 0

  return (
    <Accordion.Content
      className={tw('gap-2 overflow-y-visible p-1', className, isAnyOpen && 'mb-4')}
      forceMount
    >
      {children}
    </Accordion.Content>
  )
}

export function Root({ children, className }: React.PropsWithChildren<{ className?: string }>) {
  const { open, setOpen } = useCategoriesDataContext()

  return (
    <Accordion.Root
      type="multiple"
      className={tw(className, 'w-full')}
      value={open}
      onValueChange={(value: Collapsible[]) => {
        setOpen(value)
      }}
    >
      {children}
    </Accordion.Root>
  )
}
